'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialiseSwiper = exports.Listeners = exports.createSelectors = exports.createContext = undefined;

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _freeze = require('babel-runtime/core-js/object/freeze');

var _freeze2 = _interopRequireDefault(_freeze);

exports.ReactiveState = ReactiveState;

var _swiperEsm = require('swiper/dist/js/swiper.esm.js');

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createContext = exports.createContext = function createContext(el) {
  var context = { context: el };

  return (0, _freeze2.default)({
    className: el.dataset.moduleClass,
    getElement: function getElement(selector) {
      return (0, _functional.getElement)(selector, context);
    },
    getElements: function getElements(selector) {
      return (0, _functional.getElements)(selector, context);
    }
  });
};

var createSelectors = exports.createSelectors = function createSelectors(_ref) {
  var selectors = _ref.selectors,
      context = _ref.context;
  return (0, _entries2.default)(selectors).reduce(function (acc, _ref2) {
    var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    acc[key] = '.' + context.className + '_' + value;

    return acc;
  }, {});
};

var Listeners = exports.Listeners = {
  entries: [],

  add: function add(element, event, fn) {
    this.entries.push({ element: element, event: event, fn: fn });

    element.addEventListener(event, fn);
  },

  remove: function remove(event, fn) {
    var foundListener = this.entries.find(function (listener) {
      return listener.event === event && listener.fn === fn;
    });

    if (foundListener) {
      this.entries = this.entries.filter(function (listener) {
        return listener !== foundListener;
      });

      foundListener.element.removeEventListener(foundListener.event, foundListener.fn);
    }
  },

  removeAll: function removeAll() {
    this.entries = this.entries.filter(function (listener) {
      listener.element.removeEventListener(listener.event, listener.fn);

      return false;
    });
  }
};

function ReactiveState(initialState) {
  var _this2 = this;

  this.internalState = {};

  (0, _entries2.default)(initialState).forEach(function (_ref4) {
    var _ref5 = (0, _slicedToArray3.default)(_ref4, 2),
        key = _ref5[0],
        initialValue = _ref5[1];

    return _this2.makeKeyReactive(key, initialValue);
  });
}

ReactiveState.prototype.getPrivateKey = function getPrivateKey(key) {
  return '_' + key;
};

ReactiveState.prototype.addKey = function makeKeyReactive(key, initialValue) {
  this.makeKeyReactive(key, initialValue);
};

ReactiveState.prototype.makeKeyReactive = function makeKeyReactive(key, initialValue) {
  var _this = this;
  var privateKey = this.getPrivateKey(key);

  this.internalState[privateKey] = {
    value: initialValue,
    listeners: []
  };

  (0, _defineProperty2.default)(this, key, {
    get: function get() {
      return _this.internalState[privateKey].value;
    },
    set: function set(val) {
      _this.notify(key, val, {
        prevVal: _this.internalState[privateKey].value
      });

      _this.internalState[privateKey].value = val;
    }
  });

  return this.internalState;
};

ReactiveState.prototype.subscribe = function subscribe(key, fnc) {
  if (this.checkIfKeyInState(key)) {
    var privateKey = this.getPrivateKey(key);

    this.internalState[privateKey].listeners.push(fnc);
  }
};

ReactiveState.prototype.unsubscribe = function unsubscribe(key, fnc) {
  if (this.checkIfKeyInState(key)) {
    var privateKey = this.getPrivateKey(key);

    /* prettier-ignore */
    this.internalState[privateKey].listeners = this.internalState[privateKey].listeners.filter(function (fn) {
      return fn !== fnc;
    });
  }
};

ReactiveState.prototype.notify = function notify(key, val, _ref6) {
  var prevVal = _ref6.prevVal;

  if (this.checkIfKeyInState(key)) {
    var privateKey = this.getPrivateKey(key);

    this.internalState[privateKey].listeners.forEach(function (fn) {
      return fn(val, {
        prevVal: prevVal
      });
    });
  }
};

ReactiveState.prototype.checkIfKeyInState = function notify(key) {
  var throwError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var privateKey = this.getPrivateKey(key);
  var keyInState = privateKey in this.internalState;

  if (keyInState === false && throwError) {
    throw new Error(key + ' doesn\'t exist in ObservableState');
  }

  return keyInState;
};

var initialiseSwiper = exports.initialiseSwiper = function initialiseSwiper(container, config) {
  var swiperModules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  _swiperEsm.Swiper.use(swiperModules);

  /* eslint-disable no-new */
  return new _swiperEsm.Swiper(container, config);
};